import { Dimensions, Platform, StyleSheet } from 'react-native'

import { moderateScale, verticalScale } from '../../styles/sizes'
import { fontFamily } from '../../theme/fontFamily'
import { DS } from '../../design-system'
import { color } from '../../theme'
import { isWeb } from '@/components/WebWrapper'

const { width } = Dimensions.get('window')

export const startStyles = StyleSheet.create({
  container1: {
    flex: 0,
    backgroundColor: '#7B043D',
    height: verticalScale(35)
  },
  container2: {
    flex: 1,
    backgroundColor: '#7B043D'
  },
  onBoardingImage: {
    height: '100%',
    width: '100%'
  },
  image: {
    flex: 1,
    resizeMode: 'cover',
    justifyContent: 'center'
  },
  text: {
    color: 'white',
    fontSize: 42,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#000000a0'
  },
  orText: {
    color: 'white',
    fontSize: 16,
    textAlign: 'center'
  },
  guestText: {
    color: 'white',
    fontSize: 24,
    textAlign: 'center'
  },
  middleView: {
    paddingHorizontal: 16,
    backgroundColor: '#F6F2E9',
    alignItems: 'center'
  },
  bottomText: {
    color: '#121212',
    opacity: 0.5,
    fontSize: 14,
    textAlign: 'center',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  termsAndPrivacyText: {
    textDecorationLine: 'underline',
    backgroundColor: 'transparent',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    color: '#121212'
  },
  btnStyle: {
    marginVertical: 0,
    borderRadius: 32,
    backgroundColor: '#F6F2E9',
    borderWidth: 1,
    shadowOpacity: 0,
    borderColor: '#DDDAD2',
    width: '100%'
  },
  firstOnboardChipStyle: {
    alignSelf: 'flex-start',
    height: 72,
    width: 72,
    transform: [{ rotate: '20deg' }],
    marginTop: 20,
    marginLeft: -18
  },
  firstOnboardSuitIcon: {
    height: 20,
    width: 20,
    alignSelf: 'center',
    marginTop: -30
  },
  firstOnboardMsg: {
    marginTop: 24,
    fontSize: 32,
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#fff',
    textAlign: 'center'
  },
  firstOnboardText: {
    fontSize: 32,
    lineHeight: isWeb ? 40 : 36,
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#fff',
    textAlign: 'center'
  },
  firstOnboardGroupChipsStyle: {
    marginRight: -45,
    height: moderateScale(115),
    width: moderateScale(115),
    overflow: 'hidden'
  },
  secondOnboardGroupChipsStyle: {
    height: moderateScale(115),
    width: moderateScale(115),
    marginRight: -35,
    marginTop: -50
  },
  secondOnboardSuitIcon: {
    height: 20,
    width: 20,
    alignSelf: 'center',
    marginTop: -35
  },
  secondOnboardMsg: {
    marginTop: 24,
    fontSize: 32,
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#fff',
    textAlign: 'center'
  },
  secondOnboardSingleChipStyle: {
    marginLeft: -35,
    height: moderateScale(72),
    width: moderateScale(72),
    transform: [{ rotate: '-10deg' }]
  },
  thirdOnboardSingleChipStyle: {
    alignSelf: 'flex-start',
    height: 72,
    width: 72,
    transform: [{ rotate: '20deg' }],
    marginLeft: -39
  },
  thirdOnboardSuitIcon: {
    height: 20,
    width: 20,
    alignSelf: 'center',
    marginTop: -20
  },
  thirdOnboardMsg: {
    marginTop: 24,
    fontSize: 32,
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#fff',
    textAlign: 'center'
  },
  thirdOnboardGroupChipsStyle: {
    marginRight: -35,
    height: moderateScale(115),
    width: moderateScale(115),
    overflow: 'hidden',
    marginTop: 4
  },
  onboardContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
  },
  inputField: {
    marginTop: 8,
    height: 47,
    borderRadius: 12,
    fontSize: 16,
    paddingStart: 12,
    borderWidth: 1,
    borderColor: color.palette.smokyBlack,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  passwordError: {
    color: DS.palette['Utility/Warning'],
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: '400',
    marginTop: 8
  },
  error: {
    position: 'absolute',
    bottom: -18,
    color: DS.palette['Utility/Warning'],
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: '400'
  },
  codeFieldRoot: {
    width: '100%',
    justifyContent: 'space-between'
  },
  cell: {
    width: width * 0.12,
    height: width * 0.12,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: DS.palette['Global/Black'],
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: DS.palette['Global/White']
  },
  focusCell: {
    borderColor: '#007AFF'
  },
  cellText: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: DS.palette['Global/Black']
  },
  container: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: '#00000050'
  },
  emailAndPhoneContainer: {
    padding: 8,
    backgroundColor: 'transparent',
    marginTop: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  orView: {
    width: '100%'
  },
  leftRightView: {
    flex: 1,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  socialLoginContiner: {
    gap: 16,
    marginTop: 16,
    justifyContent: Platform.OS === 'ios' ? 'flex-end' : 'center',
    marginBottom: 20
  },
  verifyDescription: {
    alignSelf: 'center',
    marginTop: 8
  },
  line: {
    marginTop: 16,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    width: '100%'
  },
  eyeIcon: {
    width: 24,
    height: 24,
    position: 'absolute',
    right: 20,
    bottom: 10
  },
  backIcon: {
    height: 24,
    width: 24
  },
  socialLoginContainer: {
    gap: 16,
    marginTop: 16,
    justifyContent: Platform.OS === 'ios' ? 'flex-end' : 'center',
    marginBottom: 20
  }
})
